import React, { useState, useEffect } from "react";
import { useDropzone } from "react-dropzone";
import { defineMessages } from "react-intl";
import { Box, Input } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import "../error/ErrorAccordion.js";
import "../error/ErrorDetails.js";
import "../error/localize.js";
import { ErrorModal } from "../error/ErrorModal.js";
import "../error/GlobalServerErrorMessage.js";
import { LocalizedText } from "../i18n/LocalizedText.js";
import "@opentelemetry/api";
import "../../otel/TraceProvider.js";
import { withTraceErrorBoundary } from "../../otel/TraceErrorBoundary.js";
import "rxjs/operators";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import { DropzoneContent } from "./DropzoneContent.js";
const localized = defineMessages({
  dropzoneSupportedFormats: {
    id: "DZ_supportedFormats",
    defaultMessage: "Supported formats: "
  },
  dropzoneMaxFileSize: {
    id: "DZ_maxFileSize",
    defaultMessage: "Maximum size: {maxSizeInMB}MB"
  }
});
const useClasses = makeStyles()((theme) => ({
  dropzoneContainer: {
    color: theme.palette.secondary.main
  },
  dropzone: {
    border: `2px ${theme.palette.secondary.main} dashed`,
    borderRadius: theme.custom.defaultBorderRadius * 2.5,
    position: "relative",
    height: "410px"
  },
  dropzoneActive: {
    borderColor: theme.palette.primary.main,
    color: theme.palette.primary.main
  },
  dropzoneFooter: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    marginTop: theme.spacing(1)
  }
}));
const MimetypeFileFormats = {
  XLSX: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  CSV: "text/csv"
};
function DropzoneInner({ onFileUpload, onInvalidFileUpload, availableFormats, maxSizeInMB }) {
  const { classes, cx } = useClasses();
  const bytesInMB = 1048576;
  const acceptedFileFormats = {};
  availableFormats.forEach((f) => acceptedFileFormats[MimetypeFileFormats[f]] = []);
  const { acceptedFiles, fileRejections, isDragActive, isFileDialogActive, getRootProps, getInputProps, open } = useDropzone({
    noClick: true,
    accept: acceptedFileFormats,
    maxSize: maxSizeInMB * bytesInMB,
    maxFiles: 1,
    useFsAccessApi: true
  });
  const isDragOrDialogActive = isDragActive || isFileDialogActive;
  const successFile = acceptedFiles[0];
  const rejectFile = fileRejections[0];
  const [editMode, setEditMode] = useState("Default");
  useEffect(() => {
    if (!isDragActive) {
      setEditMode(rejectFile ? "Failed" : successFile ? "Success" : "Default");
    } else {
      setEditMode("Default");
    }
  }, [successFile, rejectFile, isDragActive]);
  useEffect(() => {
    if (editMode === "Success") {
      onFileUpload(successFile);
    } else if (editMode === "Failed") {
      onInvalidFileUpload();
    }
  }, [editMode]);
  return /* @__PURE__ */ React.createElement(Box, { className: classes.dropzoneContainer }, /* @__PURE__ */ React.createElement(
    Box,
    {
      ...getRootProps({
        className: cx(isDragOrDialogActive ? classes.dropzoneActive : "", classes.dropzone)
      })
    },
    /* @__PURE__ */ React.createElement(Input, { ...getInputProps() }),
    /* @__PURE__ */ React.createElement(
      DropzoneContent,
      {
        successFile,
        rejectFile,
        isDragOrDialogActive,
        onOpen: open,
        editMode
      }
    )
  ), /* @__PURE__ */ React.createElement(Box, { className: classes.dropzoneFooter }, /* @__PURE__ */ React.createElement(Box, null, /* @__PURE__ */ React.createElement(LocalizedText, { label: localized.dropzoneSupportedFormats }), availableFormats.join(", ")), /* @__PURE__ */ React.createElement(Box, null, /* @__PURE__ */ React.createElement(LocalizedText, { label: localized.dropzoneMaxFileSize, labelParams: { maxSizeInMB } }))));
}
const Dropzone = withTraceErrorBoundary(DropzoneInner, ErrorModal);
export {
  Dropzone
};
//# sourceMappingURL=Dropzone.js.map
